import axios from "axios";
import { Config } from "../config/config";
import { httpHeaderHelper } from "../helper/http-header";
import { processLoadOptions } from "../helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/user`;

export const userService = {
    async createUser(params: any) {
        return axios.post(`${GATEWAY_URL}/create-user`, params)
        .then((response) => {
            return response.data;
        });
    },

    async updateUser(keys:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-user`, params)
        .then((response) => {
            return response.data;
        });
    },

    async checkUserByEmail(email: any) {
        return axios.get(`${GATEWAY_URL}/check-user`, {
            params: { email }
        })
        .then((response) => {
            return response.data;
        });
    },

    async checkUserByUsername(username: any) {
        return axios.get(`${GATEWAY_URL}/check-user`, {
            params: { username }
        })
        .then((response) => {
            return response.data;
        });
    },

    async getUser(id: any) {
        return axios.get(`${GATEWAY_URL}/get-user`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    },

    async getUserPermissions() {
        return axios.get(`${GATEWAY_URL}/get-user-permissions`, {
            
        })
        .then((response) => {
            return response.data;
        });
    },

    async userList(loadOptions: any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/list-user`, {
            params
        })
        .then((response) => {
            return response.data;
        });
    },

    async setPassword(params: any) {
        return axios.put(`${GATEWAY_URL}/set-password`, params)
        .then((response) => {
            return response.data;
        });
    },

    async assignRole(params: any) {
        return axios.post(`${GATEWAY_URL}/assign-role`, params)
        .then((response) => {
            return response.data;
        });
    },

    async unAssignRole(userId: any, roleId: any) {
        return axios.delete(`${GATEWAY_URL}/unassign-role`, {
            params: { userId, roleId }
        })
        .then((response) => {
            return response.data;
        });
    },

    async getRoles(userId: any) {
        return axios.get(`${GATEWAY_URL}/get-roles`, {
            params: { Id: userId }
        })
        .then((response) => {
            return response.data;
        });
    },

    async updateUserLanguage(params: any) {
        return axios.put(`${GATEWAY_URL}/update-user-language`, params)
        .then((response) => {
            return response.data;
        });
    }
}
